import request from '../utils/http'
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 0  // 不同小程序对接同一后台
// const appid = 0  // 不同小程序对接同一后台

// 获取企业一级标签 154
export function getQyFirstLevelLabel() {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_industrylabel'
        }
    })
}

// 获取企业二级标签 155
export function getQyTwoLevelLabel(id) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_industrylabel2',
            parentid: id
        }
    })
}

// 获取企业三级标签 156
export function getQyThreeLevelLabel(id) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_industrylabel3',
            parentid: id
        }
    })
}

// 获取部门列表 269
export function getDeptList(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_dept',
            ...data
        }
    })
}

// 获取部门下角色 270
export function getDeptRole(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_dept_role',
            ...data
        }
    })
}

// 管理员设置成员的部门或角色 282
export function setUserDepRole(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_deptrole',
            ...data
        }
    })
}

// 获取企业列表 227 
export function getCompanyList(data) {
    return request({
        url: '/service/sumlist.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'LoadPagedams_farming_qy',
            appid,
            // appid,
            ...data
        }
    })
}

// 获取企业信息详情 199
export function getCompanyInfo(data) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user',
            ...data
        }
    })
}

// 修改企业信息 161
export function editCompany(data) {
    return request({
        url: '/service/farming.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_edit',
            appid,
            ...data
        }
    })
}

// 用户申请加入企业 263
export function applyAddCompany(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_useradd',
            ...data
        }
    })
}

// 用户申请加入企业 264
export function getApplyCompanyList(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user',
            ...data
        }
    })
}

// 取消申请加入企业 281
export function cancelApply(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_cancel',
            ...data
        }
    })
}

// 企业管理员拒绝 265
export function refuseApply(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_refuse',
            ...data
        }
    })
}

// 企业管理员同意 266
export function acceptApply(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_accept',
            ...data
        }
    })
}

// 用户退出企业 267
export function userExitCompany(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_exit',
            ...data
        }
    })
}

// 管理员把用户移除企业 268
export function userRemoveCompany(data) {
    return request({
        url: '/service/qy.ashx',
        method: "get",  //接口方法
        params: {
            Method: 'ams_farming_qy_user_del',
            ...data
        }
    })
}

